import { IApplicationState } from 'shared/types/redux';

export const selectModalWindowContent = (state: IApplicationState) => state.landing.modalWindowContent;
